import React, { useState } from 'react';
import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { isAuthed, logout } from '../../utils/api';
import AdminLogin from './AdminLogin';
import AdminList from './AdminList';
import AdminEdit from './AdminEdit';
import AdminProfileEdit from './AdminProfileEdit';
import './admin.css';

function AdminApp() {
    const [authed, setAuthed] = useState(isAuthed());

    if (!authed) {
        return <AdminLogin onLogin={() => setAuthed(true)} />;
    }

    return (
        <div className="admin-wrap">
            <header className="admin-header">
                <span className="admin-logo">Portfolio Admin</span>
                <nav className="admin-nav">
                    <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>포트폴리오</NavLink>
                    <NavLink to="/admin/profile" className={({ isActive }) => isActive ? 'active' : ''}>프로필</NavLink>
                </nav>
                <button className="admin-btn-logout" onClick={() => { logout(); setAuthed(false); }}>
                    로그아웃
                </button>
            </header>
            <Routes>
                <Route path="/admin" element={<AdminList />} />
                <Route path="/admin/new" element={<AdminEdit />} />
                <Route path="/admin/edit/:id" element={<AdminEdit />} />
                <Route path="/admin/profile" element={<AdminProfileEdit />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
        </div>
    );
}

export default AdminApp;
